/**
 * Small pill badge for status indicators.
 * Used for meal chosen/custom/takeout, weekend tier, and general status labels.
 */

const PRESETS: Record<string, string> = {
  // Meal/Weekend statuses
  won: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
  chosen: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
  custom: "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400",
  takeout: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",
  weather: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",
  // Weekend tiers
  at_home: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
  local: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
  day_trip: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",
  getaway: "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400",
};

interface StatusBadgeProps {
  text: string;
  preset?: string;
  className?: string;
}

export function StatusBadge({ text, preset, className = "" }: StatusBadgeProps) {
  const colors = preset ? PRESETS[preset] ?? PRESETS.local : "bg-gray-100 text-gray-600 dark:bg-white/10 dark:text-gray-400";

  return (
    <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded-full ${colors} ${className}`}>
      {text}
    </span>
  );
}
